import { gsap } from 'gsap'
import Lenis from 'lenis'
import {ScrollTrigger} from 'gsap/ScrollTrigger'

export class Scroll {

  isCallable () {
    return window.innerWidth > 1024
  }

  init () {
    const lenis = new Lenis({
      autoRaf: true,
      touchMultiplier: 0,
    })

    lenis.on('scroll', ScrollTrigger.update)

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);

  }
}
